module.exports = __webpack_public_path__ + "static/media/survey-icon.a400fc61.png";